import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { recentDemoVisitorId } from "@/lib/demoVisitor";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [booting, setBooting] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("moneyme_token");
    if (!token) {
      setUser(null);
      setBooting(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("moneyme_token");
      setUser(null);
    } finally {
      setBooting(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("moneyme_token", data.access_token);
    setUser(data.user);
  };

  const setProfileType = async (profile_type) => {
    const { data } = await api.patch("/auth/profile-type", { profile_type });
    setUser(data.user);
  };

  const completeTour = async () => {
    const { data } = await api.patch("/auth/tour-complete");
    setUser(data.user);
  };

  const register = async (name, email, password, profile_type) => {
    const { data } = await api.post("/auth/register", { name, email, password, profile_type, demo_visitor_id: recentDemoVisitorId() });
    localStorage.setItem("moneyme_token", data.access_token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("moneyme_token");
    setUser(null);
  };

  const setRegion = async (region) => {
    const { data } = await api.patch("/auth/region", { region });
    setUser(data.user);
  };

  return (
    <AuthContext.Provider value={{ user, booting, login, register, logout, setRegion, setProfileType, completeTour, refreshUser: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
